
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mentions",
      function () {
        return require("private-next-pages/mentions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mentions"])
      });
    }
  